import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_APP_API_URL: z.string().min(1),
    VITE_APP_TRACK_URL: z.string().min(1),
  },
  server: {
    SENTRY_AUTH_TOKEN: z.string(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
